module.exports = __webpack_public_path__ + "2fb20be6f2f25537fe7c7e0bd526c1d0.svg";